
export const getCalculatedImageSize = (
    width: number,
    height: number,
    maxWidth: number = 700,
    maxHeight: number = 700
) => {
  // Если изображение помещается в оба лимита, возвращаем исходные размеры
  if (width <= maxWidth && height <= maxHeight) {
    return { width, height }
  }

  // Вычисляем коэффициенты масштабирования для обоих измерений
  const widthRatio = maxWidth / width
  const heightRatio = maxHeight / height

  // Выбираем меньший коэффициент, чтобы изображение поместилось в оба лимита
  const scale = Math.min(widthRatio, heightRatio)

  return {
    width: Math.round(width * scale),
    height: Math.round(height * scale)
  }
}

export const getCalculatedImageSizeMaxWidth = (width: number, height: number, maxWidth: number = 700) => {
  if (width <= maxWidth) {
    return { width, height }
  }

  const aspectRatio = height / width
  return { width: maxWidth, height: Math.round(maxWidth * aspectRatio) }
}
